import React, { useEffect, useState } from 'react';
import './result.css'
import { socket } from '../../io';

function Result() {
  const games = [];

  return (
    <div className="container-result">
      {games.map((game, index) => (
        <div key={index} className="">
          <div className="row">
            <div className="">{}</div>
            <div className="">{}</div>
          </div>
          <div className="game">
            <div className="team">{}</div>
            <div className="score">{}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Result